import { useSelector } from 'react-redux';
import { ExareStatus, InsuranceType } from '@websky/graphql';
import { getRequestIsAutomaticMode, getRequestPrices, getRequestStatus } from '../model';
import { useHasPaidInsurances } from '@entities/order';

export const useRequestNotifications = () => {
	const isAutomaticMode = useSelector(getRequestIsAutomaticMode);
	const status = useSelector(getRequestStatus);
	const prices = useSelector(getRequestPrices);

	const showInsuranceAlphaOrSirenaMessage = useHasPaidInsurances([
		InsuranceType.AlphaInsurance,
		InsuranceType.SirenaInsurance
	]);

	const isZeroPrice = prices?.priceToPay?.amount && Math.abs(prices.priceToPay.amount) <= 0;

	const showCaculationMessage = !isAutomaticMode;
	const showReturnMessage = isAutomaticMode && !isZeroPrice && status === ExareStatus.Finished;

	const showNotifications = [showCaculationMessage, showReturnMessage, showInsuranceAlphaOrSirenaMessage].some(
		notification => notification
	);

	return {
		showNotifications,
		notifications: { showCaculationMessage, showReturnMessage, showInsuranceAlphaOrSirenaMessage }
	};
};
